import React, { useCallback, useEffect, useRef, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import LinearGradient from 'utils/packages/linearGradient';
import { SquircleView } from 'react-native-figma-squircle';
import MaskedView from '@react-native-masked-view/masked-view';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Modal from 'utils/packages/Modal';
import { rem } from 'design-system/values';
import { muteAll, muteErrorAndFetching, useFetchOld } from 'hooks';
import useColors from 'hooks/useColors';
import FreeShareView from './FreeShareView';
import IconGift from '../icons/IconGift';
import IconGo from '../icons/IconGo';
import * as actions from '../actions';
const strings = {
    congrats: 'Congratulations!',
    claimYourFreeShare: 'Claim your free share',
};
const ClaimFreeShare = () => {
    const [hidden, setHidden] = useState(false);
    const [freeSharesClaimableResponse, , , fetchFreeShares] = useFetchOld(muteErrorAndFetching);
    const [, , , claimFreeShares] = useFetchOld(muteAll);
    const timeoutRef = useRef(undefined);
    useEffect(() => {
        fetchFreeShares(actions.getFreeSharesClaimable());
        return () => {
            clearTimeout(timeoutRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onClaim = useCallback(async () => {
        const ref = React.createRef();
        Modal.show(<FreeShareView ref={ref}/>, {
            fullscreen: true,
            fade: true,
            nonDismissable: true,
        });
        const response = await claimFreeShares(actions.claimFreeShare());
        if (response) {
            ref.current?.setState({ name: response.name, amount: response.amount, logoUrl: response.logo });
            timeoutRef.current = setTimeout(() => {
                setHidden(true);
            }, 1000);
        }
    }, [claimFreeShares]);
    const colors = useColors();
    if (!freeSharesClaimableResponse?.freeSharesClaimable || hidden) {
        return null;
    }
    return (<TouchableBounce onPress={onClaim} style={styles.touchable}>
      <MaskedView style={styles.outerContainer} maskElement={<SquircleView style={styles.outerContainer} squircleParams={{
                cornerSmoothing: 1,
                cornerRadius: rem(20),
                fillColor: 'white', // it’s a mask, a color scheme independent thing
            }}/>}>
        <LinearGradient style={styles.container} {...colors.gradients.brandCards}>
          <IconGift />
          <Spacer w={16}/>
          <View style={styles.infoContainer}>
            <Text Text-16 White>
              {strings.congrats}
            </Text>
            <Text TextThin-14 White>
              {strings.claimYourFreeShare}
            </Text>
          </View>
          <Spacer w={16}/>
          <IconGo />
        </LinearGradient>
      </MaskedView>
    </TouchableBounce>);
};
const marginHorizontal = rem(16);
const styles = StyleSheet.create({
    touchable: {
        marginHorizontal,
        marginVertical: rem(8),
    },
    outerContainer: {
        height: rem(72),
    },
    container: {
        height: rem(72),
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: rem(24),
    },
    infoContainer: {
        flex: 1,
    },
});
export default ClaimFreeShare; // do not wrap into memo - needs to be re-rendered on every parent’s render
